// assets/custom-product.js
// MOXIE: system-bottom.liquid loads this asset only on product templates.
// This asset has order-delivery, product-description, and screen-capture.
// The audit kept these classes in one product asset because the evidence does not prove one block owner.
import { $4, VariantChangeBase } from "@theme/global";

// https://unpkg.com/dayjs@1.11.10/dayjs.min.js
import dayjs from "@theme/dayjs";
dayjs.locale('en'); // use locale globally

class orderDelivery extends VariantChangeBase {
  constructor() {
    super();
    this.config = JSON.parse(this.getAttribute('config'));
    this.offDays = this.config.off_day.replace(/ /g, '').split(",");
    this.nowDay = dayjs();
    var format_day = this.config.format_day,
      time = this.config.time.replace("24:00:00", "23:59:59"),
      arrDayWeek = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],
      dateStart = this.config.estimateStartDate || 0,
      dateEnd = this.config.estimateEndDate || 0,
      excludeDays = this.config.cut_day.replace(/ /g, '').split(","),
      startDay = dayjs(),
      i = 0,
      endDay = dayjs(),
      j = 0,
      nowTime = this.nowDay.format('HHmmss'),
      timeint = time.replace(/ /g, '').replace(/:/g, ''),

      arrDay = themeHDN.extras.order.dayNames.replace(/ /g, '').split(","),
      arrMth = themeHDN.extras.order.monthNames.replace(/ /g, '').split(",");

    /**
     * Check Time, if nowTime >=  timeint +1 day
     */
    if (parseInt(nowTime) >= parseInt(timeint)) {
      this.nowDay = this.nowDay.add(1, 'day');
      startDay = startDay.add(1, 'day');
      endDay = endDay.add(1, 'day');
    }

    /**
     * Mode: 2 - Shipping + delivery
     * Mode: 1 - Only delivery
     */

    if (this.config.mode == '2') {

      // START DATE
      // if ngay khach mua trung voi ngay loai tru tang 1 ngay
      while (excludeDays.indexOf(arrDayWeek[startDay.format('d')]) > -1 || this.offDays.indexOf(startDay.format('DD/MM/****')) > -1 || this.offDays.indexOf(startDay.format('DD/MM/YYYY')) > -1) {
        startDay = startDay.add(1, 'day');
      }
      while (i < dateStart) {
        i++;
        startDay = startDay.add(1, 'day');
        if (excludeDays.indexOf(arrDayWeek[startDay.format('d')]) > -1 || this.offDays.indexOf(startDay.format('DD/MM/****')) > -1 || this.offDays.indexOf(startDay.format('DD/MM/YYYY')) > -1) {
          i--;
        }
      }

      // END DATE
      // if ngay khach mua trung voi ngay loai tru tang 1 ngay
      while (excludeDays.indexOf(arrDayWeek[endDay.format('d')]) > -1 || this.offDays.indexOf(endDay.format('DD/MM/****')) > -1 || this.offDays.indexOf(endDay.format('DD/MM/YYYY')) > -1) {
        endDay = endDay.add(1, 'day');
      }

      while (j < dateEnd) {
        j++;
        endDay = endDay.add(1, 'day');
        if (excludeDays.indexOf(arrDayWeek[endDay.format('d')]) > -1 || this.offDays.indexOf(endDay.format('DD/MM/****')) > -1 || this.offDays.indexOf(endDay.format('DD/MM/YYYY')) > -1) {
          j--;
        }
      }

    }
    else {

      // START DATE
      startDay = startDay.add(dateStart, 'day');
      while (excludeDays.indexOf(arrDayWeek[startDay.format('d')]) > -1 || this.offDays.indexOf(startDay.format('DD/MM/****')) > -1 || this.offDays.indexOf(startDay.format('DD/MM/YYYY')) > -1) {
        startDay = startDay.add(1, 'day');
      }

      // END DATE
      endDay = endDay.add(dateEnd, 'day');
      while (excludeDays.indexOf(arrDayWeek[endDay.format('d')]) > -1 || this.offDays.indexOf(endDay.format('DD/MM/****')) > -1 || this.offDays.indexOf(endDay.format('DD/MM/YYYY')) > -1) {
        endDay = endDay.add(1, 'day');
      }
      // endDay = endDay.add(this.offDaysf(endDay), 'day');

    }

    /**
     * Translate day, month
     * https://day.js.org/docs/en/display/format
     */

    arrDay = this.ArrUnique(arrDay);
    arrMth = this.ArrUnique(arrMth);

    var startDayDInt = parseInt(startDay.format('D')),
      daystStart = startDayDInt + this.nth(startDayDInt),
      MntStart = arrMth[parseInt(startDay.format('M')) - 1],
      dayStart = arrDay[parseInt(startDay.format('d'))],

      EndDayDInt = parseInt(endDay.format('D')),
      daystEnd = EndDayDInt + this.nth(EndDayDInt),
      MntEnd = arrMth[parseInt(endDay.format('M')) - 1],
      dayEnd = arrDay[parseInt(endDay.format('d'))];

    //console.log( startDayDInt, EndDayDInt )
    if ($4('[data-start-delivery]', this)) $4('[data-start-delivery]', this).innerHTML = startDay.format(format_day).replace('t44', dayStart).replace('t45', daystStart).replace('t46', MntStart);
    if ($4('[data-end-delivery]', this)) $4('[data-end-delivery]', this).innerHTML = endDay.format(format_day).replace('t44', dayEnd).replace('t45', daystEnd).replace('t46', MntEnd);
  }

  ArrUnique(arr) {
    var onlyUnique = function (value, index, self) {
      return self.indexOf(value) === index;
    };
    return arr.filter(onlyUnique);
  }

  nth(d) {
    if (d > 3 && d < 21) return 'th';
    switch (d % 10) {
      case 1: return "st";
      case 2: return "nd";
      case 3: return "rd";
      default: return "th";
    }
  }
  #preVariantId;
  onVariantChanged(event) {
    const variant = event.detail.variant;
    if (variant && this.#preVariantId != variant.id) {
      if (variant.available) {
        this.closest(".hdt-product-info__item").style.display = ""
        if (variant.variant_state.pre_order && this.config?.hideWithPreorder) {
          this.closest(".hdt-product-info__item").style.display = "none"
        }
      }
      else {
        this.closest(".hdt-product-info__item").style.display = "none"
      }
    }
  }
}
customElements.define('order-delivery', orderDelivery);


// AQUI INICIA
// --------------------------
// Countdown (simple)
// --------------------------
// MOXIE: movida desde custom.js — solo se usa en blocks/_product-order.liquid (PDP). Reutiliza el
// import de dayjs de arriba, ya cargado en este archivo.
class countdownSimple extends HTMLElement {
  x = 0;
  constructor() {
    super();

    /** Countdown
     * [days] [hours] [mins] [secs]
     */

    this.config = JSON.parse(this.getAttribute('config'));
    const time = this.config.time.replace("24:00:00", "23:59:59")

    if (time == '19041994') return;
    this.textTemp = $4("template", this).innerHTML;
    this.notHasDay = !this.textTemp.includes('[days]');
    let today = dayjs();

    const nowTime = today.format('HHmmss'),
      configTime = time.replace(/ /g, '').replace(/:/g, '')

    if (parseInt(nowTime) >= parseInt(configTime)) {
      today = today.add(1, 'day');
    }
    // Set the date we're counting down to
    // "2030-01-05 15:37:25"
    this.countDownDate = new Date(`${today.format('YYYY-MM-DD')} ${time}`).getTime();

    // Update the count down every 1 second
    this.#update();
    this.x = setInterval(this.#update.bind(this), this.textTemp.includes('[secs]') ? 1000 : 60000);
  }
  #update() {
    // Get today's date and time
    const now = new Date().getTime();

    // Find the distance between now and the count down date
    const distance = this.countDownDate - now;

    // Time calculations for days, hours, minutes and seconds
    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);
    if (this.notHasDay) hours = days * 24 + hours;

    // Display the result in the element
    this.innerHTML = this.textTemp.replace('[days]', String(days).padStart(2, '0')).replace('[hours]', String(hours).padStart(2, '0')).replace('[mins]', String(minutes).padStart(2, '0')).replace('[secs]', String(seconds).padStart(2, '0'));

    // If the count down is finished, write some text
    if (distance < 0) {
      clearInterval(this.x);
      // EXPIRED
      this.hidden = true
    }
  }
  disconnectedCallback() {
    clearInterval(this.x);
  }
}
customElements.define('hdt-countdown-simple', countdownSimple);
// AQUI FINALIZA


// product description - readmore
class ProductDescription extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      this.init();
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 0px 0px' }).observe(this);
  }
  init() {

    this.lm_btn = this.querySelector('[data-button]');
    this.content = this.querySelector('[data-content]');
    this.m_h = parseInt(this.dataset.heightLimit);
    if (!this.lm_btn || !this.content || !this.m_h) return;

    let content_h = this.content.scrollHeight;
    // console.dir(this.content);
    if (this.m_h > content_h) {
      this.lm_btn.style.setProperty('display', 'none');
      return;
    }

    this.content.style.setProperty('--height', `${content_h}px`);
    this.content.style.setProperty('max-height', `${this.m_h}px`);
    this.content.style.setProperty('--max-height', `${this.m_h}px`);

    this.lm_btn.addEventListener('click', () => {
      this.classList.toggle('is--less');
    })
  }
}
customElements.define('product-description', ProductDescription);

// Custom Element Test - Simple Version
class ScreenCaptureElement extends HTMLElement {
  constructor() {
    super();
    this.capturedImageData = null;
    this.render();
    this.bindEvents();
  }

  // Simple render without CSS
  render() {
    this.innerHTML = `
     <div>        
      <a id="capture-btn" style="
        background: none;
        border: none;
        color: inherit;
        font-size: inherit;
        font-family: inherit;
        font-weight: inherit;
        cursor: pointer;
        padding: 0;
        margin: 0;
        text-decoration: underline;
      ">${this.getAttribute('button-text') || 'Test Capture'}</a>
      <div id="status-message" style="
        margin-top: 10px;
        font-size: 14px;
        color: #666;
      "></div>
      <div id="progress-bar" style="display: none; margin-top: 10px;">Processing...</div>
    </div>
    `;
  }

  // Bind events
  bindEvents() {
    const captureBtn = this.querySelector('#capture-btn');
    captureBtn.addEventListener('click', () => this.captureScreen());
  }

  showStatus(message) {
    const statusMessage = this.querySelector('#status-message');
    statusMessage.textContent = message;
    console.log('Status:', message);
  }
  // Simple button state
  setButtonsState(disabled) {
    const captureBtn = this.querySelector('#capture-btn');
    captureBtn.disabled = disabled;
  }

  // Update button text with loading animation
  updateButtonText(text, isLoading = false) {
    const captureBtn = this.querySelector('#capture-btn');
    if (isLoading) {
      captureBtn.innerHTML = `<span class="loading-text"><span class="loading-spinner"></span>${text}</span>`;
    } else {
      captureBtn.innerHTML = text;
    }
  }
  // Test capture function
  async captureScreen() {
    try {
      this.setButtonsState(true);
      this.updateButtonText('Đang tải thư viện...', true);

      // Wait for libraries to load
      console.error = () => { };
      console.warn = () => { };
      console.log = () => { };

      // Also suppress window.onerror
      window.onerror = () => true;

      this.updateButtonText('Waiting...', true);

      // Use modern-screenshot
      console.log('Using modern-screenshot');
      const dataUrl = await window.modernScreenshot.domToJpeg(document.body, {
        quality: 0.4,
        width: window.innerWidth,
        height: document.body.scrollHeight,
        compress: true,
        ignoreElements: (element) => {
          return element.classList?.contains('cart-drawer') ||
            element.classList?.contains('wishlist') ||
            element.classList?.contains('compare') ||
            element.classList?.contains('predictive-search') ||
            element.classList?.contains('shopify-section-group-footer-group') ||
            element.classList?.contains('shopify-section-group-header-group') ||
            element.classList?.contains('shopify-section-group-header-group') ||
            element.classList?.contains('shopify-section-group-header-group') ||
            element.tagName === 'SCRIPT' ||
            element.tagName === 'header' ||
            element.tagName === 'footer' ||
            element.tagName === 'noscript' ||
            element.tagName === 'NOSCRIPT';
        },
      });

      this.capturedImageData = dataUrl;

      this.updateButtonText('Generating PDF...', true);
      this.showStatus('Capture successful! Generating PDF...');
      await this.generatePDF();
    } catch (error) {
      this.updateButtonText('Error', false);
      this.showStatus('Error: ' + error.message);
    } finally {
      this.setButtonsState(false);
      // Reset button text to original
      const originalText = this.getAttribute('button-text') || 'Test Capture';
      this.updateButtonText(originalText, false);
    }
  }

  async generatePDF() {
    try {
      this.showStatus('Generating PDF...');
      const { jsPDF } = window.jspdf;
      const pdf = new jsPDF({
        orientation: 'portrait',
        width: window.innerWidth,
        height: document.body.scrollHeight,
        unit: 'mm',
        format: [900, 1200],
      });

      const img = new Image();
      img.src = this.capturedImageData;

      await new Promise((resolve) => {
        img.onload = resolve;
      });
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      // Tính tỷ lệ scale để fit ảnh
      const scaleX = pageWidth / img.width;
      const scaleY = pageHeight / img.height;
      const scale = Math.min(scaleX, scaleY); // Chọn scale nhỏ hơn

      const finalWidth = img.width * scale;
      const finalHeight = img.height * scale;

      // Center ảnh trên trang
      const x = (pageWidth - finalWidth) / 2;
      const y = (pageHeight - finalHeight) / 2;

      pdf.addImage(this.capturedImageData, 'JPEG', x, y, finalWidth, finalHeight, undefined, 'FAST');

      const filename = `screen-capture-${Date.now()}.pdf`;
      pdf.save(filename);

      this.updateButtonText('PDF generated successfully!', false);
      this.showStatus('PDF generated successfully!');

    } catch (error) {
      this.updateButtonText('Error generating PDF', false);
      this.showStatus('PDF Error: ' + error.message);
    } finally {
    }
  }

  connectedCallback() {
    setTimeout(() => {
      console.log('Library status check:', {
        modernScreenshot: !!window.modernScreenshot,
        jspdf: !!window.jspdf
      });
    }, 1000);
  }
}

customElements.define('screen-capture', ScreenCaptureElement);
